import Vue from 'vue';
import { Swipe, SwipeItem} from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);